import { render, staticRenderFns } from "./reportingWorker.vue?vue&type=template&id=21537b98&"
import script from "./reportingWorker.vue?vue&type=script&lang=js&"
export * from "./reportingWorker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports